<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="vx-row mb-base mt-5">
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-8/12 xl:w-8/12 padding-2"
      >
        <div class="payment-card">
          <vs-card>
            <div class="loading-bar" v-if="loading">
              <atom-spinner
                :animation-duration="1000"
                :size="60"
                color="#ff1d5e"
                class="mx-auto"
              />
            </div>
            <div class="header">
              <vs-icon icon="credit_card" class="icon-header" />
              <span>{{$t("customers.label.Payment")}}</span>
            </div>

            <div class="amount">
              <p>
                {{$t("customers.label.CustomerToPay")}}
                <strong class="text-success"
                  >{{ basketData.planData[0].currencySymbol }}
                  {{ basketDetails.totalPrice.toFixed(2) }}</strong
                >
              </p>
            </div>

            <div class="monthly-payment">
              <p><strong>{{$t("customers.label.MonthlyPayment")}}</strong></p>
              <p>{{$t("customers.label.SetupWithDirectDebitOrCreditCard")}}</p>
              <p class="amount">
                {{ basketData.planData[0].currencySymbol }}
                {{ basketDetails.totalPrice.toFixed(2) }}
              </p>
            </div>
            <div class="m-2 pt-3 text-center justify-center">
              <span class="ml-1 mr-2">
                <vs-button
                  @click="handleSendLink"
                  :disabled="
                    !(
                      paymentStatusData &&
                      (paymentStatusData.id === undefined ||
                        paymentStatusData.status === 'expired')
                    )
                  "
                  :loading="loading"
                >
                  {{$t("customers.label.SendLinkToCustomerToCompletePayment")}}
                </vs-button>
              </span>
            </div>
            <div class="m-2 pt-3 text-center justify-center">
              <span class="ml-1 mr-2">
                <vs-button
                  @click="handlePaymentStatus"
                  :disabled="
                    !paymentStatusData.id ||
                    paymentStatusData.status === 'expired'
                  "
                  :loading="loading"
                >
                  {{$t("customers.label.CheckPaymentStatus")}}
                </vs-button>
              </span>
            </div>
            <div
              v-if="showDidNotReceiveMail"
              class="m-2 pt-1 text-center justify-center"
            >
              <span
                class="didnt-receive-mail"
                @click="showMailPopup = true"
                style="color: red; cursor: pointer;"
              >
                Didn't receive the mail? <span style="color: green;">Click here</span>
              </span>
            </div>
            <!-- <div class="my-4">
              <h6 class="ml-1">iDEAL and other Payment Option</h6>
              <div class="payment-icons mt-3">
                <img src="@/assets/images/flags/iDEAL.png" alt="iDEAL" />
                <img
                  src="@/assets/images/flags/apple-pay.png"
                  alt="Apple Pay"
                />
                <img src="@/assets/images/flags/g-pay.png" alt="Google Pay" />
              </div>
            </div> -->
          </vs-card>
          <vs-popup
              :active.sync="showMailPopup"
              title="Didn't receive the mail?"
              class="popup-close"
            >
              <div>
                <div class="mb-2">
                  <strong>Payment Link:</strong>
                  <a :href="url" target="_blank" style="word-break: break-all;">
                    {{ url }}
                  </a>
                  <span
                  >
                  <feather-icon
                      icon="CopyIcon"
                      title="Copy Link"
                      svgClasses="w-5 h-5 ml-3 mt-1 stroke-current cursor orange_icon"
                      @click="copyToClipboard"
                      class="icon_row"
                    />
                  </span>
                </div>
                <vs-button @click="showMailPopup = false" class="ml-2 mt-3">
                  Close
                </vs-button>
              </div>
            </vs-popup>
        </div>
      </div>
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-4/12 padding-2"
      >
        <div class="vx-card p-4">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex items-center basketSection">
                <img src="@/assets/images/pages/basketIcon.svg" />
                <h3 class="ml-3">{{$t("customers.label.Basket")}}</h3>
              </div>
            </div>
          </div>
          <div>
            <div
              class="p-2"
              :style="
                (basketData && basketData.pairedItemSerialNumber) ||
                (basketData && basketData.serialNumber.length > 14)
                  ? {
                      border:
                        elapsedTime > 59
                          ? '4px solid #00FF00'
                          : '4px solid #FF0000',
                    }
                  : {}
              "
            >
              <span
                class="font-bold flex items-center justify-between"
                v-if="
                  (basketDetails && basketDetails.pairedItemSerialNumber) ||
                  (basketDetails && basketDetails.serialNumber.length > 14)
                "
              >
                {{$t("customers.label.ThisNumberIsReservedFor")}}
                <Timer
                  @update-timer="updateElapsedTime"
                  :elapsedTime="elapsedTime"
                />
              </span>
              <p class="mb-2 text-success">
                ✅ {{$t("customers.label.YouSelected")}} {{ basketDetails.selectedSimText }}
              </p>
              <!-- <p
                v-if="basketDetails.itemSerialNumber"
                class="mb-2 text-success"
              >
                ✅ Serial No - {{ basketDetails.itemSerialNumber }}
              </p>
              <p
                v-if="basketDetails.pairedItemSerialNumber"
                class="mb-2 text-success"
              >
                ✅ Phone No - {{ basketDetails.pairedItemSerialNumber }}
              </p>
              <p
                v-if="
                  basketDetails.simType === 'Postpaid' &&
                  basketDetails.serialNumber.length > 12
                "
                class="mb-2 text-success"
              >
                ✅ Serial No - {{ basketDetails.serialNumber }}
              </p>
              <p
                v-if="
                  basketDetails.simType === 'Postpaid' &&
                  basketDetails.phoneNumber
                "
                class="mb-2 text-success"
              >
                ✅ Phone No - {{ basketDetails.phoneNumber }}
              </p> -->
              <p class="mb-2 text-success">
                ✅ {{$t("customers.label.SerialNo")}} -
                {{
                  basketDetails.itemSerialNumber || basketDetails.serialNumber
                }}
              </p>
              <p class="mb-2 text-success">
                ✅ {{$t("customers.label.PhoneNo")}} -
                {{
                  basketDetails.phoneNumber ||
                  basketDetails.pairedItemSerialNumber
                }}
              </p>
            </div>
            <basket
              v-for="(data, i) in basketData.planData"
              :key="i"
              title="Bundle"
              :detailsHtml="data.text"
              :discountedPrice="data.finalPrice"
              :currencySymbol="data.currencySymbol"
              :originalPrice="data.price"
              buttonType="change"
              buttonLabel="Change"
              :planName="data.planName"
              @action="changePlan"
              :promoDetails="data.promodata"
            />
            <basket
              v-for="(data, i) in basketData.addonData"
              :key="i"
              title="Addon"
              :detailsHtml="data.text"
              :discountedPrice="data.finalPrice"
              :originalPrice="data.price"
              buttonType="change"
              buttonLabel="Change"
              :planName="data.planName"
              @action="changePlan"
            />

            <p class="mb-2 mt-2 text-success" v-if="basketData.shippingCharge">
              ✅ Shipping Charge:
              {{ basketData.shippingCharge }}
            </p>
            <div class="text-gray-700 font-semibold">
              {{$t("customers.label.TotalPrice")}}
              <span style="color: green"
                >{{ basketData.planData[0].currencySymbol
                }}{{
                  basketDetails.totalPrice &&
                  basketDetails.totalPrice.toFixed(2)
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row justify-center" v-if="isActivatingCustomer">
      <span class="ml-1 mr-2"> {{$t("customers.label.ActivatingCustomer")}} </span>
    </div>
    <div class="vx-row justify-center" v-if="orderStatusLoading">
      <span class="ml-1 mr-2"> {{$t("customers.label.LoadingOrderStatus")}} </span>
    </div>
    <div
      class="vx-row justify-center"
      v-if="hasPaymentResponse && !orderStatusLoading"
    >
      <span class="ml-1 mr-2 text-xl font-medium">
        {{$t("customers.label.OrderStatus")}}
        <span
          style="color: green"
          v-if="orderInfo && orderInfo.order_status == 'Success'"
        >
          {{ orderInfo && orderInfo.order_status }}
        </span>
        <span style="color: red" v-else> {{$t("customers.label.Failed")}} </span>
      </span>
    </div>
    <!-- adyen section -->
    <div id="component-container"></div>
  </div>
</template>

<script>
import { AdyenCheckout, Card } from "@adyen/adyen-web";
import { AtomSpinner } from "epic-spinners";

import "@adyen/adyen-web/styles/adyen.css";
import { mapState } from "vuex";
import basket from "@/components/basket.vue";
import Timer from "@/components/Timer.vue";
export default {
  name: "PaymentCard",

  data() {
    return {
      showMailPopup: false,
      showDidNotReceiveMail: false,
      url: "",
      hasPaymentResponse: false,
      orderStatusLoading: false,
      orderInfo: {},
      basketDetails: {},
      checkout: null,
      isPaymentProcessing: false,
      isActivatingCustomer: false,
      dropin: null,
      paymentMethods: [],
      cardComponent: null,
      loading: false,
    };
  },
  components: {
    basket,
    Timer,
    AtomSpinner,
  },

  computed: {
    ...mapState({
      elapsedTime: (state) => state.customerActivationNew.elapsedTime,
      basketData: (state) => state.customerActivationNew.basketData,
      adynSessionData: (state) => state.customerActivationNew.adynSessionData,
      paymentStatusData: (state) =>
        state.customerActivationNew.paymentStatusData,
      customerActivationData: (state) =>
        state.customerActivationNew.customerActivationDraft,
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    updateElapsedTime(time) {
      this.$store.commit("customerActivationNew/setElapsedTime", time);
    },
    changePlan() {
      this.$router.push("/customers/customer_activation/plan-info");
    },
    async handleSendLink() {
      let payload = {
        amount: {
          currency: this.basketData.planData[0].currencyCode,
          value: Math.round(this.basketData.totalPrice * 100),
        },
        description: "Test",
        countryCode: "GB",
        shopperLocale: "en-GB",
        email: this.customerActivationData.clientData[0].email,
        pkgName: this.basketData.planData[0].planName,
        subsName:
          this.customerActivationData.clientData[0].firstname +
          " " +
          this.customerActivationData.clientData[0].lastname,
      };
      try {
        this.loading = true;
        await this.$store.dispatch(
          "customerActivationNew/sendLinkAction",
          payload
        );
        console.log(
          "Payment link sent successfully",
          this.paymentStatusData.url
        );
        this.url = this.paymentStatusData.url;

        this.$swal({
          title: "info",
          icon: "info",
          text: "Payment Link Successfully Sent.",
          type: "info",
        });
        this.showDidNotReceiveMail = true;
      } catch (error) {
        this.$swal({
          title: "error",
          icon: "error",
          text: "Not able to send payment link! Try again later.",
          type: "error",
        });
      }
      this.loading = false;
    },
    copyToClipboard() {
  if (!this.url) return;
  navigator.clipboard
    .writeText(this.url)
    .then(() => {
      this.$swal({
        title: "Copied!",
        text: "Payment link copied to clipboard.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
    })
    .catch(() => {
      this.$swal({
        title: "Failed",
        text: "Could not copy the link.",
        icon: "error",
      });
    });
},
    async handlePaymentStatus() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "customerActivationNew/checkPaymentStatus",
          this.paymentStatusData.id
        );
        this.loading = false;
        if (this.paymentStatusData.status === "completed") {
          // this.$swal({
          //   title: "Success",
          //   icon: "success",
          //   text: "Payment Successful!",
          //   type: "success",
          // });
          this.activateCustomer();
        } else if (this.paymentStatusData.status === "active") {
          this.$swal({
            title: "info",
            icon: "info",
            text: "Payment is pending!",
            type: "info",
          });
        } else if (this.paymentStatusData.status === "expired")
          this.$swal({
            title: "Expired",
            icon: "warning",
            text: "Payment Link Expired! Try Again.",
            type: "warning",
          });
      } catch (error) {
        this.loading = false;
        if(error && error.message && error.message.error && error.message.error.responseBody){
          const parsedError = JSON.parse(error.message.error.responseBody)
          this.$swal({
            title: "Error",
            icon: "error",
            text: parsedError.message,
            type: "error",
          });
        } else{
          this.$swal({
            title: "Error",
            icon: "error",
            text: "Something Went Wrong",
            type: "error",
          });
        }
      }
    },
    async activateCustomer() {
      this.isActivatingCustomer = true;
      this.loading = true;
      let payload = {
        paymentResponse: this.paymentStatusData,
        activationData: this.customerActivationData,
      };
      try {
        this.loading = true;
        const resp = await this.$store.dispatch(
          "customerActivationNew/simpleActivationAction",
          payload
        );
        this.loading = false;
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Customer Activation Created Successfully!",
          type: "success",
        });
        this.$router.push(
          `/customers/customer_activation/confirm?id=${resp.data.resourceIdentifier}`
        );
      } catch (error) {
        this.loading = false;
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Something went wrong",
          type: "error",
        });
      } finally {
        this.isActivatingCustomer = false;
        this.loading = false;
      }
    },
    async fetchOrderStatus() {
      this.orderStatusLoading = true;
      let payload = {
        orderId: this.$route.params.orderId,
        // redirectResult: this.$route.query.redirectResult,
        redirectResult: this.$route.query.redirectResult,
      };
      try {
        let res = await this.$store.dispatch(
          "customerActivationNew/orderStatus",
          payload
        );
        this.orderInfo = res.data;
        if (this.orderInfo.order_status == "Success") {
          this.$router.push("/customers/customer_activation/confirm");
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      } finally {
        this.orderStatusLoading = false;
      }
    },
    // async getPaymentMethods() {
    //   try {
    //     this.paymentMethods = [];
    //     const res = await this.$store.dispatch(
    //       "customerActivationNew/fetchPaymentMethods",
    //       {
    //         amount: 1000,
    //         currency: "EUR",
    //       }
    //     );
    //     this.paymentMethods = res.data;
    //   } catch (error) {
    //     this.$swal({
    //       title: "Error",
    //       icon: "error",
    //       text: "Something went wrong",
    //       type: "error",
    //     });
    //   }
    // },
    // nextTab() {
    //   this.$router.push("/customers/customer_activation/confirm");
    // },
  },
  mounted() {
    // this.getPaymentMethods();
    if (this.basketData && this.basketData.totalPrice) {
      this.basketDetails = this.basketData;
      localStorage.setItem("basketData", JSON.stringify(this.basketData));
    } else this.basketDetails = JSON.parse(localStorage.getItem("basketData"));

    this.hasPaymentResponse = false;
    // if (
    //   Object.keys(this.$route.params).length &&
    //   Object.keys(this.$route.query).length
    // ) {
    //   this.hasPaymentResponse = true;
    //   this.fetchOrderStatus();
    // }
  },
};
</script>

<style scoped>
.didnt-receive-mail {
  font-size: 1rem;
  color: #007bff;
  cursor: pointer;
}
.payment-card {
  margin: auto;
  position: relative;
}
.loading-bar {
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.icon-header {
  margin-right: 10px;
  color: #00c8b2;
  font-size: 20px;
}

.amount {
  margin-bottom: 15px;
  font-size: 1rem;
  font-weight: bold;
}

.monthly-payment .amount {
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: -28px;
  float: right;
}

.monthly-payment {
  padding: 15px;
  background-color: #effef1;
}

.payment-icons img {
  width: 50px;
  height: 40px;
  margin: 0 10px;
  cursor: pointer;
}
</style>
